import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPolygonIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 7,
	viewBox: "0 0 12 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6 7L0 1.17772e-06L12 0L6 7Z",
		fill: "#FDFDFC"
	})]
});
const ForwardRef = forwardRef(SvgPolygonIcon);
export { ForwardRef as ReactComponent };
